import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import ArrowLeftIcon from 'mdi-react/ArrowLeftIcon';
import ArrowRightIcon from 'mdi-react/ArrowRightIcon';
import TooltipComponent from '@prisjakt/ui-tooltip-new';
import Button from '@prisjakt/ui-button';

const ARROW_ICON_MARGIN = '-3px';

const Tooltip = styled(TooltipComponent)``;

const FilterToggleButton = styled.button`
  display: flex;
  align-items: center;
  align-self: stretch;
  outline: none;
  cursor: pointer;
  padding: 0 8px;
  min-height: 43px;
  position: relative;
  fill: ${props =>
    props.active ? props.theme.colors.base700 : props.theme.colors.base400};
  background-color: ${props =>
    props.active ? props.theme.colors.yellove500 : 'transparent'};
  svg {
    margin-top: -1px;
  }

  :hover {
    svg g,
    svg path {
      fill: ${props =>
        props.active
          ? props.theme.colors.base700
          : props.theme.colors.positive500};
    }
  }
`;

const ArrowIconLeft = styled(ArrowLeftIcon)`
  margin-left: ${ARROW_ICON_MARGIN};
`;

const ArrowIconRight = styled(ArrowRightIcon)`
  margin-left: ${ARROW_ICON_MARGIN};
`;

const SidebarFilterButton = styled(Button)`
  margin-left: ${layout.spacing.xSmall};
`;

export {
  Tooltip,
  FilterToggleButton,
  ArrowIconLeft,
  ArrowIconRight,
  SidebarFilterButton,
};
